import React, {
  FunctionComponent,
  createContext,
  useState,
  useEffect,
} from 'react'

import './App.scss'
import search from './utils/search'
import { CALENDAR, CONTACTS, DROPBOX, SLACK, TWEET } from './data/Data'
import SearchBar from './components/SearchBar'
import SearchResults from './components/SearchResults'
import SearchItem from './utils/SearchItem'

interface ContextType {
  variable: any
  setVariable: React.Dispatch<React.SetStateAction<any>>
}

export const useSearchQuery = createContext<ContextType | undefined>(undefined)
export const useFilter = createContext<ContextType | undefined>(undefined)
export const useSort = createContext<ContextType | undefined>(undefined)
export const useInstantSearch = createContext<ContextType | undefined>(
  undefined
)

const App: FunctionComponent = () => {
  const [query, setQuery] = useState('')
  const [filter, setFilter] = useState({
    calendar: true,
    contacts: true,
    dropbox: true,
    slack: true,
    tweet: true,
  })
  const [sort, setSort] = useState('alphabetical')
  const [instantSearch, setInstantSearch] = useState({
    isOn: false,
    delay: 0.7,
  })

  const [calendarData, setCalenderData] = useState([] as SearchItem[])
  const [contactsData, setContactsData] = useState([] as SearchItem[])
  const [dropboxData, setDropboxData] = useState([] as SearchItem[])
  const [slackData, setSlackData] = useState([] as SearchItem[])
  const [tweetData, setTweetData] = useState([] as SearchItem[])

  useEffect(() => {
    setCalenderData(search(CALENDAR, query))
    setContactsData(search(CONTACTS, query))
    setDropboxData(search(DROPBOX, query))
    setSlackData(search(SLACK, query))
    setTweetData(search(TWEET, query))
  }, [query])

  return (
    <useSearchQuery.Provider value={{ variable: query, setVariable: setQuery }}>
      <useFilter.Provider value={{ variable: filter, setVariable: setFilter }}>
        <useSort.Provider value={{ variable: sort, setVariable: setSort }}>
          <useInstantSearch.Provider
            value={{ variable: instantSearch, setVariable: setInstantSearch }}
          >
            <div className='container'>
              <SearchBar />
              <SearchResults
                calendarData={calendarData}
                contactsData={contactsData}
                dropboxData={dropboxData}
                slackData={slackData}
                tweetData={tweetData}
              />
            </div>
          </useInstantSearch.Provider>
        </useSort.Provider>
      </useFilter.Provider>
    </useSearchQuery.Provider>
  )
}

export default App
